import { addLayoutRequest, deleteLayoutRequest, editLayoutRequest } from "api/layout";

import { addNewLayoutSucess, deleteNewLayoutSucess, editLayoutSucess, setCurrentLayout, setLayouts, showOverlayLoader } from "../actions/layout";

export const addLayout =
  (page, layoutName, isHome, layoutUserID = null, AddFromLayout = null, scheduling = null, AutoReport, baselineId=null) =>
  async dispatch => {
    try {
      dispatch(showOverlayLoader(true));
      if(baselineId!==null){
        baselineId = parseInt(baselineId);
      }
      const response = await addLayoutRequest(page, layoutName, isHome, layoutUserID, AddFromLayout, scheduling, AutoReport, baselineId);
      if (response) {
        let newLayout = response.Layouts[0];
        const isNewlyAdded = !AddFromLayout;
        newLayout = { ...newLayout, isNewlyAdded };
        dispatch(addNewLayoutSucess(page, newLayout));
        dispatch(setCurrentLayout(page, newLayout));
      }
    } catch (err) {
      console.log("Add Layout Error: ", err);
    } finally {
      dispatch(showOverlayLoader(false));
    }
  };

export const deleteLayout =
  (page, id, admin = false, addToUser = "", layouts) =>
  async dispatch => {
    try {
      dispatch(showOverlayLoader(true));
      const response = await deleteLayoutRequest(page, id);
      if (response) {
        dispatch(deleteNewLayoutSucess(page, id));
      }
    } catch (err) {
      console.error("Delete Layout Error: ", err);
    } finally {
      dispatch(showOverlayLoader(false));
    }
  };

export const editLayout = (page, currentLayout, newName, isHome, scheduling, autoReport) => async dispatch => {
  try {
    dispatch(showOverlayLoader(true));
    const response = await editLayoutRequest(page, currentLayout.Name, currentLayout.ID, newName, isHome, scheduling, autoReport);
    if (response) {
      const layout = response.Layouts[0];
      dispatch(editLayoutSucess(page, layout));
    }
  } catch (err) {
    console.log("Edit Layout Error: ", err);
  } finally {
    dispatch(showOverlayLoader(false));
  }
};

export const setPageLayouts = (layouts, selectedLayout, page) => dispatch => {
  dispatch(setLayouts(page, layouts));
  selectedLayout = selectedLayout || layouts[0];
  dispatch(setCurrentLayout(page, selectedLayout));
};
